module.exports = __webpack_public_path__ + "static/media/image.439fa6d6.svg";